//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "NielsenTab",
  props: ["value"],
  methods: {
    updateData() {
      this.$emit("value", this.value);
    }
  }
}
